<div style="margin-top: 5%;">
    <div class="topDiv">
        <nav mat-tab-nav-bar mat-stretch-tabs>
          <a mat-tab-link
              *ngFor="let link of navLinks"
              [routerLink]="link.link"
              routerLinkActive #rla="routerLinkActive"
              [active]="rla.isActive">
              {{link.label}}
          </a>
        </nav>
        <router-outlet></router-outlet>
    </div>
</div>

